import { hot } from 'react-hot-loader/root';

import { createInitializer } from 'client/platforms/init';
import { App as StatvalueApp } from 'client/platforms/statvalue/components/app';

export const App = hot(StatvalueApp);
export const init = createInitializer(StatvalueApp);
